import Action from 'actions';

export function getActiveGamesSinceTeamGameTimeline(team) {
    const {
        playersData: {games, filters},
    } = Action.getState();

    const gamesList = games.getAllAsArr();
    const result = {};

    for (const teamGame of gamesList) {
        if (!inArray(team, Object.keys(teamGame.teams))) {
            continue;
        }

        gamesList.map((game) => {
            if (teamGame.gameTimestamp > game.gameTimestamp) {
                return;
            }
            getGameTeamNames(game).map((team) => {
                if (inArray(team, filters.games)) {
                    result[game.gameTimestamp] ??= {
                        teams: [],
                        gameTimestamp: game.gameTimestamp,
                    };
                    result[game.gameTimestamp].teams.push(team);
                }
            });
        });

        break;
    }

    return Object.values({...result});
}

export function getGamesIndexedByTeamName() {
    const {
        playersData: {games},
    } = Action.getState();

    const result = {};

    games.getAllAsArr().map((game) => getGameTeamNames(game).map((team) => result[team] = game));

    return result;
}

export function getTeamNamesOfGames(games) {
    const teamNames = [];

    games.map((game) => getGameTeamNames(game).map((team) => teamNames.push(team)));

    return teamNames;
}

export function getGameTeamNames(game) {
    return Object.keys(game.teams);
}

export function parseGameInfo(gameInfo) {
    return gameInfo.split('@');
}
